<template>
  <div style="padding: 10px">
    <h2>《{{ form.appName }}隐私政策》</h2>
    <div>生效时间：【2022-7-14】 更新时间：【2022-7-14】</div>
    <h3 class="title">提示条款</h3>
    <p class="content">
      在使用【{{
        form.appName
      }}】各项产品或服务前，请您务必仔细阅读并透彻理解本政策，特别是以粗体/粗体下划线标识的条款，您应重点阅读，在确认充分理解并同意后再开始使用。如对本政策内容有任何疑问、意见或建议，您可通过【{{
        form.appName
      }}】提供的各种联系方式与我们联系。
      您的信任对我们非常重要，我们深知个人信息对您的重要性，我们将按法律法规要求，采取相应安全保护措施，尽力保护您的个人信息安全可控。鉴于此，【{{
        form.appName
      }}】服务提供者（或简称“我们”或“【{{
        form.appName
      }}】”）制定本《隐私政策》（下称“本政策
      /本隐私政策”）并提醒您：本政策适用于【{{
        form.appName
      }}】提供的所有产品和服务及我们的关联公司的产品或服务（如【{{
        form.appName
      }}】小程序），您可使用【{{
        form.appName
      }}】平台帐号登录上述产品或服务，如上述产品或服务未设独立隐私政策的，则本政策同样适用于该部分产品或服务。
      需要特别说明的是，本政策不适用于其他第三方向您提供的服务，也不适用于【{{
        form.appName
      }}】中已另行独立设置隐私政策的产品或服务。
    </p>

    <h3 class="title">第一部分 定义</h3>
    <p class="content">
      【{{ form.appName }}】服务提供者：【{{ form.companyName }}】
      <br />
      公司注册地址：【{{ form.companyCity }}】
      <br />
      个人信息：指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息。
      <br />
      个人敏感信息：指包括身份证件号码、个人生物识别信息、银行账号、财产信息、行踪轨迹、交易信息、14岁以下（含）儿童信息个人信息（我们将在本隐私政策中对具体个人敏感信息以粗体进行显著标识）。
      <br />
      个人信息删除：指在实现日常业务功能所涉及的系统中去除个人信息的行为，使其保持不可被检索、访问的状态。
      <br />
      儿童：指不满十四周岁的未成年人。
      <br />
      除另有约定外，本政策所用定义与【{{
        form.appName
      }}】平台用户协议中的定义具有相同的涵义。
    </p>
    <h3 class="title">第二部分 隐私政策</h3>
    <p class="content">
      本隐私政策部分将帮助您了解以下内容：
      <br />
      一、我们如何收集和使用您的信息
      <br />
      二、我们如何使用Cookie
      <br />
      三、我们如何共享、转让、公开披露您的信息
      <br />
      四、我们如何存储您的信息
      <br />
      五、我们如何保护您的信息
      <br />
      六、您如何管理您的信息
      <br />
      七、我们如何处理未成年人的信息
      <br />
      八、您的信息如何在全球范围转移
      <br />
      九、本隐私政策如何更新
      <br />
      十、如何联系我们
    </p>
    <h3 class="title">一、我们如何收集和使用您的信息</h3>
    <p class="content">
      在您使用我们的产品及/或服务时，我们需要/可能需要收集和使用的您的个人信息包括如下两种：
      <br />
      1、为实现向您提供我们产品及/或服务的基本功能，我们将按照《网络安全法》的规定收集、使用您的个人信息。如您拒绝提供相应信息，您将无法正常使用我们的产品及/或服务，但不影响您浏览我们的网页及客户端页面；
      <br />
      2、为实现向您提供我们产品及/或服务的附加功能，您可选择授权我们收集、使用您的个人敏感信息。如您拒绝提供，您将无法正常使用相关附加功能或无法达到我们拟达到的功能效果，但并不会影响您正常使用我们产品及/或服务的基本功能。
      <br />
      您理解并同意：
      <br />
      1、我们致力于打造多样的产品和服务以满足您的需求。因我们向您提供的产品和服务种类众多，且不同用户选择使用的具体产品/服务范围存在差异，因此基本/附加功能及收集使用的个人信息类型、范围会有所区别，请以具体的产品/服务功能为准；
      <br />
      2、为给您带来更好的产品和服务体验，我们在持续努力改进我们的技术，随之我们可能会不时推出新的或优化后的功能，可能需要重新收集、使用您的个人信息或变更个人信息使用目的或方式。对此，我们将通过更新本政策、弹窗、页面提示方式另行向您说明对应信息的收集目的、范围及使用方式，并征求您的明示同意。在此过程中，如果您有任何疑问、意见或建议的，您可通过【{{
        form.appName
      }}】提供的各种联系方式与我们联系，我们会尽快为您作出解答。
      <br />
      我们会为实现本政策下述的各项功能，收集和使用您的个人信息：
      <br />
      <span style="font-weight: 1000">（一） 帮助您成为我们的会员</span>
      <br />
      1、基础会员服务
      <br />
      注册成为会员并使用我们的会员服务，您需要提供手机号码、拟使用的会员名和密码用于创建【{{
        form.appName
      }}】平台账户。如果您仅需使用浏览、搜索服务，您不需要注册成为我们的会员及提供上述信息。
      在您登录帐户时，我们可能会根据您提供的上述信息校验您的会员身份，确保我们是在为您本人提供服务。若存在依法需确定您会员身份的场景（包括依法为您扣缴税费、行政执法或司法诉讼中相关主体认定等）时，您授权我们可获取您对应支付账户的相关认证信息用于上述目的。
      我们会根据您的会员账户使用情况为您提供相应会员所对应的基本权益。
      <br />
      2、附加会员服务
      <br />
      如果您选择提供真实姓名、性别、出生年月日、居住地个人信息，我们可以为您提供更加的会员服务。为保证交易辨识度，您的帐户昵称、头像将公开显示。
      <br />
      授权登录：经您同意后我们向第三方共享您的账户信息（如微信，我们可能会共享您的头像、昵称），使您可以便捷地以【{{
        form.appName
      }}】平台帐户实现第三方平台的注册或登录。此外，我们可能会根据您的授权从第三方处获取您的第三方账户信息，并与您的【{{
        form.appName
      }}】平台账户进行绑定，使您可通过第三方账户直接登录、使用我们的产品及/或服务。我们将在您授权同意的范围内使用您的相关信息。
      <br />
      提现功能：经您同意后，我们将取得您的真实姓名、手机号码信息，与您已有的支付宝帐号进行实名匹配验证；验证通过后，您可以将【{{
        form.appName
      }}】中的费用提现至您的支付宝中。
      <br />
      其他会员角色服务：如果您申请注册成为卖家、服务商或其他存在额外身份认证要求的会员角色，您应当向我们提供身份信息及/或企业相关信息，或授权我们自其他处获取您对应账户的上述相关认证信息，用于您身份及特殊会员角色获取资格的核验、登记、公示及其他我们明确告知的目的。
      <br />
      3、账户信息展示：
      <br />
      如果您已拥有【{{ form.appName }}】平台账户，我们可能会在【{{
        form.appName
      }}】平台服务中显示您的上述个人信息（实人认证仅显示认证是否通过的结果），以及您在【{{
        form.appName
      }}】平台上或与【{{
        form.appName
      }}】平台账户相关联的产品和服务中执行的操作（您可通过【{{
        form.appName
      }}】平台账户在我们提供的手机【{{
        form.appName
      }}】入口或其他产品/服务入口使用我们及/或关联公司提供的产品或服务），包括通过【{{
        form.appName
      }}】平台账户集中展示您的个人资料、优惠权益、交易订单。我们会尊重您对【{{
        form.appName
      }}】平台服务和【{{ form.appName }}】平台账户设置所做的选择。 （二）
      为您提供商品或服务信息展示
      <br />
      服务日志信息：当您使用我们的网站或客户端提供的产品或服务时，我们会自动收集您对我们服务的详细使用情况，作为服务日志保存，包括浏览、点击查看、搜索查询、收藏、添加至购物车、交易、售后、关注分享信息、发布信息，以及IP地址、浏览器类型、电信运营商、使用语言、访问日期和时间。
      请注意，单独的设备信息、服务日志信息是无法识别特定自然人身份的信息。如果我们将这类非个人信息与其他信息结合用于识别特定自然人身份，或者将其与个人信息结合使用，则在结合使用期间，这类非个人信息将被视为个人信息，除取得您授权或法律法规另有规定外，我们会将这类信息做匿名化、去标识化处理。
      如果您不想接受我们给您发送的商业广告，您可按照信息中提示的退订步骤进行退订或与我们的客服联系进行退订。在您使用我们提供的站内搜索服务时，我们也同时提供了不针对您个人偏好的商品、服务。
      此外，我们也会为了不断改进和优化上述的功能来使用您的上述信息。
      <br />
      <span style="font-weight: 1000">
        （三） 为您提供收藏、加购、关注与分享功能
      </span>
      <br />
      在您浏览我们客户端的过程中，您可以选择对的商品及/或服务进行收藏、添加至购物车、与您的商家/品牌建立关注关系、通过我们提供的功能组件向其他第三方分享信息。在您使用上述功能的过程中，我们会收集包括您的收藏及添加购物车的记录、关注关系、分享历史在内的服务日志信息用于实现上述功能及其他我们明确告知的目的。
      <br />
      <span style="font-weight: 1000">（四）帮助您完成下单及订单管理</span>
      <br />
      当您在我们的产品及/或服务中订购具体商品及/或服务时，我们会通过系统为您生成购买该商品及/或服务的订单。在下单过程中,您需至少提供您的收货人姓名、收货地址、收货人联系电话，同时该订单中会载明您所购买的商品及/或服务信息、具体订单号、订单创建时间、您应支付的金额，我们收集这些信息是为了帮助您顺利完成交易、保障您的交易安全、查询订单信息、提供客服与售后服务及其他我们明确告知的目的。
      您可以通过【{{
        form.appName
      }}】为其他人订购商品及/或服务，您需要提供该实际订购人的前述个人信息，若其中涉及儿童个人信息的，您需在提供前征得对应儿童监护人的同意。
      为便于您了解查询订单信息并对订单信息进行管理，我们会收集您在使用我们服务过程中产生的订单信息用于向您展示及便于您对订单进行管理。
      您可额外填写/选择包括其他联系电话、收货时间在内的更多附加信息以确保商品或服务的准确送达。
      <br />
      <span style="font-weight: 1000">（五） 帮助您完成支付</span>
      <br />
      为完成订单支付，您需要提供支付账户并选择付款方式，我们会将您的【{{
        form.appName
      }}】平台账户会员名、对应的支付账户会员名、订单支付相关信息及其他反洗钱法律要求的必要信息与第三方支付公司共享。如您选择由其他金融机构为您提供支付服务的，我们或我们的关联公司、合作伙伴还会将您的包括银行卡号、有效期在内的银行卡支付必要信息与您选择的相应金融机构共享。
      您可以请求其他人为您付款，那么您需要提供代付人的支付账户及/或手机号码。
      为使我们及时获悉并确认您的支付进度及状态，为您提供售后与争议解决服务，您同意我们可自您所选择的交易对象、支付公司或您选择的其他金融机构处收集与支付进度相关信息。
      <br />
      <span style="font-weight: 1000">（六） 帮助向您完成商品或服务的交付</span>
      <br />
      为保证您购买的商品及/或服务能够顺利、安全、准确送达，我们会向为【{{
        form.appName
      }}】平台提供物流信息系统和技术服务的物流配送公司披露订单相关配送信息，并由其根据商品及/或服务提供主体的指定向相应的物流配送主体同步相关配送信息。您知晓并同意相应物流配送主体不可避免地获知及使用您的配送信息，用于完成交付目的。
      为使我们及时获悉并确认交付进度及状态，向您提供售后与争议解决服务，您同意我们可自物流相关服务主体处收集与交付进度相关信息。
      <br />
      <span style="font-weight: 1000">（七） 客服及争议处理</span>
      <br />
      当您与我们联系或提出售中售后、争议纠纷处理申请时，为了保障您的账户及系统安全，我们需要您提供必要的个人信息以核验您的会员身份。
      <br />
      为便于与您联系、尽快帮助您解决问题或记录相关问题的处理方案及结果，我们可能会保存您与我们的通信/通话记录及相关内容（包括账号信息、订单信息、您为了证明相关事实提供的其他信息，或您留下的联系方式信息），如果您针对具体订单进行咨询、投诉或提供建议的，我们会使用您的账号信息和订单信息。
      <br />
      <span style="font-weight: 1000">（八） 为您提供安全保障</span>
      <br />
      为提高您使用我们及我们关联公司、合作伙伴提供服务的安全性，保护您或其他用户或公众的人身财产安全免遭侵害，更好地预防钓鱼网站、欺诈、网络漏洞、计算机病毒、网络攻击、网络侵入安全风险，更准确地识别违反法律法规或【{{
        form.appName
      }}】相关协议规则的情况，我们可能使用或整合您的会员信息、交易信息、设备信息、服务日志信息以及我们关联公司、合作伙伴取得您授权或依据法律共享的信息，来综合判断您账户及交易风险、进行身份验证、检测及防范安全事件，并依法采取必要的记录、审计、分析、处置措施。
      <br />
      <span style="font-weight: 1000">（九）为您提供其他附加服务</span>
      <br />
      为向您提供更便捷、更优质的产品及/或服务，努力提升您的体验，我们在向您提供的以下附加服务中可能会收集、缓存和使用您的个人信息。如果您不提供这些信息，不会影响您使用【{{
        form.appName
      }}】的浏览、搜索基本服务，但您可能无法获得这些附加服务给您带来的用户体验。这些附加服务包括：
      <br />
      1、基于相机/摄像头的附加服务：您可在开启相机（摄像头）权限后使用该功能。即使您已同意开启相机（摄像头）权限，我们也仅会在您主动点击相应图标或录制视频时通过相机获取照片信息。。
      <br />
      2、基于读取、写入外置存储卡的附加服务：您可以在开启存储权限后，使用该功能上传您的照片/图片/视频，以实现发表评论/分享或与客服沟通提供证明等功能。
      <br />
      3.基于读取手机状态和身份信息的附加服务：我们将在您开启权限后收集您的IMEI、MSI、设备MAC地址、软件列表、设备序列号、android
      ID，根据您的设备确认您的账户安全，实现安全风控。
      <br />
      4、基于查看WLAN连接的附加功能：查看wifi连接状态，确保网络可靠性以及大流量场景下提示用户流量使用。
      <br />
      5、基于检索正在运行应用的附加功能：此功能可以使您在浏览【{{
        form.appName
      }}】商品、服务时跳转到第三方APP的指定页面。
      <br />
      6、基于相册（图片库/视频库）的图片/视频访问及上传、外部存储、缓存、发布音视频功能的附加服务：您可在开启相册权限后使用该功能上传您的照片/图片/视频，发表评论/分享、拍照购物或与客服沟通提供证明等功能。我们可能会通过您所上传的照片/图片来识别
      您需要购买的商品或服务，或使用包含您所上传照片或图片的评论信息。您如果拒绝授权提供，将无法使用此功能，但不影响您正常使用【{{
        form.appName
      }}】的其他功能。
      <br />
      7、基于麦克风的语音技术相关附加服务：您可在开启麦克风权限后使用麦克风实现语音购物功能，或与客服联系或与客服机器人实现语音交互，在这些功能中我们会收集您的录音内容以识别您的购物需求，或响应您的客服及争议处理等需求。请您知晓，即使您已同意开启麦克风权限，我们也仅会在您主动点击客户端内麦克风图标或录制视频时通过麦克风获取语音信息。
      <br />
      8、基于安装应用的附加服务：平台会定期更新应用的客户端，您可以在更新的时候，打开APP直接进行新版本的更新安装及使用。
      <br />
      9、基于应用程序获得当前运行任务的信息的附加服务：平台在统计APP数据的情况下，会对APP的页面进行判断。
      <br />
      10、基于保持APP在唤醒状态下的附加服务：您在本应用观看视频的情况下，需要保持应用为唤醒的状态。
      <br />
      您理解并同意，上述附加服务可能需要您在您的设备中开启您的位置信息
      （地理位置）、摄像头（相机）、相册（图片库）、麦克风（语音）及/或日历、外部存储的访问权限，以实现这些权限所涉及信息的收集和使用。请您注意，您开启任一权限即代表您授权我们可以收集和使用相关个人信息来为您提供对应服务，您一旦关闭任一权限即代表您取消了授权，我们将不再基于对应权限继续收集和使用相关个人信息，也无法为您提供该权限所对应的服务。但是，您关闭权限的决定不会影响此前基于您的授权所进行的信息收集及使用。
      <br />
      <span style="font-weight: 1000">（十）其他</span>
      <br />
      1、若你提供的信息中含有其他用户的个人信息，在向【{{
        form.appName
      }}】提供这些个人信息之前，您需确保您已经取得合法的授权。若其中涉及儿童个人信息的，您需在发布前取得对应儿童监护人的同意，前述情形下监护人有权通过本政策第十条的途径联系我们，要求更正或删除涉及儿童个人信息的内容。
      <br />
      2、若我们将信息用于本政策未载明的其他用途，或者将基于特定目的收集而来的信息用于其他目的，或者我们主动从第三方处获取您的个人信息，均会事先获得您的同意。
      <br />
      若我们从第三方处间接获取您的信息的，我们会在收集前明确以书面形式要求该第三方在已依法取得您同意后收集个人信息，并向您告知共享的信息内容，且涉及敏感信息的在提供给我们使用前需经过您的明确确认，要求第三方对个人信息来源的合法性和合规性作出承诺，如第三方有违反行为的，我们会明确要求对方承担相应法律责任；同时，我们对个人信息会进行安全加固（包括敏感信息报备、敏感信息加密存储、访问权限控制）。我们会使用不低于我们对自身用户个人信息同等的保护手段与措施对间接获取的个人信息进行保护。
      <br />
      3、征得授权同意的例外
      <br />
      您充分理解并同意，我们在以下情况下收集、使用您的个人信息无需您的授权同意，且我们可能不会响应您提出的更正/修改、删除、注销、撤回同意、索取信息的请求：
      <br />
      （1）与国家安全、国防安全有关的；
      <br />
      （2）与公共安全、公共卫生、重大公共利益有关的；
      <br />
      （3）与犯罪侦查、起诉、审判和判决执行等司法或行政执法有关的；
      <br />
      （4）出于维护您或其他个人的生命、财产相关的重大合法权益但又很难得到本人同意的；
      <br />
      （5）您自行向社会公众公开的个人信息；
      <br />
      （6）从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道。
      <br />
      （7）根据与您签订和履行相关协议或其他书面文件所必需的；
      <br />
      （8）用于维护所提供的产品及/或服务的安全稳定运行所必需的，例如发现、处置产品及/或服务的故障；
      <br />
      （9）为合法的新闻报道所必需的；
      <br />
      （10）学术研究机构基于公共利益开展统计或学术研究所必要，且对外提供学术研究或描述的结果时，对结果中所包含的个人信息进行去标识化处理的；
      <br />
      （11）法律法规规定的其他情形。
      <br />
      请知悉，根据适用的法律，若我们对个人信息采取技术措施和其他必要措施进行处理，使得数据接收方无法重新识别特定个人且不能复原，或我们可能会对收集的信息进行去标识化地研究、统计分析和预测，用于改善【{{
        form.appName
      }}】的内容和布局，为商业决策提供产品或服务支撑，以及改进我们的产品和服务（包括使用匿名数据进行机器学习或模型算法训练），则此类处理后数据的使用无需另行向您通知并征得您的同意。
      <br />
      4、如我们停止运营【{{
        form.appName
      }}】产品或服务，我们将及时停止继续收集您个人信息的活动，将停止运营的通知以逐一送达或公告的形式通知您，并对我们所持有的与已关停业务相关的个人信息进行删除或匿名化处理。涉及儿童个人信息的，我们会并将停止运营的通知及时告知儿童监护人。
      <br />
      二、我们如何使用Cookie
      <br />
      Cookie通常包含标识符、站点名称以及一些号码和字符。借助Cookie，我们能够存储您的账户信息、商品记录、订单记录、商品的数据。
      <br />
      若您不同意我们在您的移动设备上存储Cookie的小数据文件，您可停止使用【{{
        form.appName
      }}】。
      <br />

      我们如何使用 Cookie 和同类技术
      <br />
      <span style="font-weight: 1000">（一）Cookie</span>
      <br />
      为确保网站正常运转，我们会在您的计算机或移动设备上存储名为 Cookie
      的小数据文件。Cookie 通常包含标识符、站点名称以及一些号码和字符。借助于
      Cookie，网站能够存储您的偏好或购物篮内的商品等数据。
      <br />
      我们不会将 Cookie
      用于本政策所述目的之外的任何用途。您可根据自己的偏好管理或删除
      Cookie。您可以清除计算机上保存的所有 Cookie，大部分网络浏览器都设有阻止
      Cookie
      的功能。但如果您这么做，则需要在每一次访问我们的网站时亲自更改用户设置。
      <br />
      <span style="font-weight: 1000">（二）关于SDK、IMEI、MAC的使用</span>
      <br />

      为向您提供更便捷、更优质的产品及/或服务，努力提升您的体验，我们会收集您的设备型号、操作系统、唯一设备标识符、登录IP地址、操作日志、MAC地址、应用程序列表信息。我们在向您提供的以下附加服务中可能会收集和使用您的个人信息。如果您不提供这些信息，不会影响您使用我们平台的浏览、搜索、购买等基本服务，但您可能无法获得这些附加服务给您带来的用户体验。这些附加服务包括：
      收集IMEI与MAC地址
      --目的：能更快定位用户反馈的关于可能由手机型号导致的相关兼容性问题，开展问题分析与研究，改善我们的产品与服务。
      <br />

      talkingdata --
      目的：用于应用内统计分析；方式：APP内代码部署；范围：仅用于APP内行为，帮助收集、处理、分析一方数据，可视化运营指标，帮助产品设计及改进。
      友盟+ --
      目的：用于应用内数据分析与业务增长闭环运营工具；方式：APP内代码部署；范围：帮助稳定性，卡顿错误类型上报，提供行为日志，快速还原错误现场，助力APP稳定性优化。
      <br />
      腾讯QQ浏览器X5的内核服务 --
      目的：主要用于在线浏览word文档，excell文档，pdf文档及图片等；方式：APP内加载；范围：仅限于在APP内打开word文档，excell文档，pdf文档及图片等时。
      apicloud --
      APP采用混合模式开发，基于APICloud框架编译打包生成安装包。（该开发平台底层框架包含位置服务，用于用户地区分布统计，记录APP内各地区使用人数）。
      极光、小米、华为 --
      用于站内信，为用户提供信息接收功能，以便用户及时最新了解最新信息。
      <br />
      【Android版】
      <br />
      wxPayPlus --目的：用于为用户提供支付功能，以便用户内购购买。
      <br />
      wxPlus --
      目的:可用于实现微信账号登录，分享内容到朋友圈或好友、收藏等功能；轻松、高效集成微信功能到自己的
      app 内。使自己的 app 和微信实现无缝链接。
      <br />
      aliPayPlus --目的: 用于为用户提供支付功能，以便用户内购购买。
      <br />
      【ios+ Android版】
      <br />
      clSDKShanYanSDKModule
      --目的:闪验一键登录，手机号、主要用于登录注册账号使用，及接收运营商验证码.
      <br />
      huaweiPush--目的: 用于用户接收通知和透传消息功能。
      <br />
      shareAction--目的: 用于用户通过该功能能够分享一些最常见的文本，图片信息等
      <br />
      clipBoard--目的:用户可以通过此功能对自己的信息内容剪切、复制、相关操作。
      <br />
      QQPlus—目的：用于用户通过该功能能够分享一些最常见的文本，图片信息等。
      <br />
      fs —目的：通过此模块对文件或文件夹进行创建、删除、读取、写入等相关操作。
      <br />
      downloadManager--目的：所有的下载进程进行管理，用户可以通过界面来查看下载进度等信息，同时还提供压缩包解压、快速查看下载完成文件等功能
      <br />

      【软件安装列表敏感信息行为】
      <br />
      在您登录账号时勾选用户协议与隐私政策登录成功之后才会获取信息给您带来最优的用户体验，未登录之前不会获取信息
      <br />
      您理解并同意的同时请您注意，开启权限即代表您授权我们可以收集和使用相关个人信息来为您提供对应服务，您一旦关闭任一权限即代表您取消了授权，我们将不再基于对应权限继续收集和使用相关个人信息，也无法为您提供该权限所对应的服务。但是，您关闭权限的决定不会影响此前基于您的授权所进行的信息收集及使用。
      <br />
    </p>

    <h3 class="title">三、我们如何共享、转让、公开披露您的信息</h3>
    <p class="content">
      <span style="font-weight: 1000">
        （一）共享 我们不会与【{{
          form.appName
        }}】服务提供者以外的公司、组织和个人共享您的个人信息，但以下情况除外：
      </span>
      <br />
      1、在法定情形下的共享：我们可能会根据法律法规规定、诉讼、争议解决需要，或按行政、司法机关依法提出的要求，对外共享您的个人信息。
      <br />
      2、在获取明确同意的情况下共享：获得您的明确同意后，我们会与其他方共享您的个人信息。
      <br />
      3、在您主动选择情况下共享：您通过【{{
        form.appName
      }}】平台购买商品或服务，我们会根据您的选择，将您的订单信息中与交易有关的必要信息共享给相关商品或服务的提供者，以实现您的交易及售后服务需求。
      <br />
      4、与关联公司间共享：为便于我们基于【{{
        form.appName
      }}】平台账户向您提供产品和服务，您可能的信息，识别会员账号异常，保护【{{
        form.appName
      }}】关联公司或其他用户或公众的人身财产安全免遭侵害，您的个人信息可能会与我们的关联公司和/或其指定的服务提供商共享。我们只会共享必要的个人信息，且受本隐私政策中所声明目的的约束，如果我们共享您的个人敏感信息或关联公司改变个人信息的使用及处理目的，将再次征求您的授权同意。
      <br />
      5、与授权合作伙伴共享：我们可能委托授权合作伙伴为您提供某些服务或代表我们履行职能，我们仅会出于本隐私政策声明的合法、正当、必要、特定、明确的目的共享您的信息，授权合作伙伴只能接触到其履行职责所需信息，且不得将此信息用于其他任何目的。对于涉及儿童个人信息的，我们不允许合作伙伴进行转委托。
      目前，我们的授权合作伙伴包括以下类型：
      <br />
      （1）广告、分析服务类的授权合作伙伴。我们会委托这些合作伙伴处理与广告覆盖面和有效性相关的信息，但不会提供您的个人身份信息，或者我们将这些信息进行去标识化处理，以便它不会识别您个人。这类合作伙伴可能将上述信息与他们合法获取的其他数据相结合，以执行我们委托的广告服务或决策建议，帮助其在不识别您个人身份的前提下提升广告有效触达率。
      <br />
      （2）供应商、服务提供商和其他合作伙伴。我们将信息发送给支持我们业务的供应商、服务提供商和其他合作伙伴，这些支持包括受我们委托提供的技术基础设施服务、分析我们服务的使用方式、衡量广告和服务的有效性、提供客户服务、支付便利或进行学术研究和调查，这些信息难以与您的身份信息相关联，这些信息将帮助我们分析、衡量广告和相关服务的有效性。
      <br />
      为保障我们客户端的稳定运行、功能实现，使您能够使用和享受更多的服务及功能，我们的应用中会嵌入授权合作伙伴的SDK。我们会对授权合作伙伴获取有关信息的应用程序接口（API）、软件工具开发包（SDK）进行严格的安全检测，并与授权合作伙伴约定严格的数据保护措施，令其按照本政策以及其他任何相关的保密和安全措施来处理个人信息。
      具体如下：
      <br />
    </p>

    <h3 class="title">SDK简称：中国移动号码认证SDK</h3>
    <p class="content">
      合作方：中国移动
      <br />
      合作方类型：免密号码友盟合作方
      <br />
      合作目的：提供移动端设备移动手机号免密号码验证服务
      <br />
      个人信息收集方式：嵌入第三方SDK，SDK收集传输个人信息、设备信息
      <br />
      个人信息收集范围：当前手机号的掩码
      <br />
      隐私政策：
      <a href="https://wap.cmpassport.com/resources/html/contract.html">
        https://wap.cmpassport.com/resources/html/contract.html
      </a>
      <br />
    </p>
    <h3 class="title">SDK简称：中国联通号码认证SDK</h3>
    <p class="content">
      合作方：中国联通
      <br />
      合作方类型：免密号码友盟合作方
      <br />
      合作目的：提供移动端设备联通手机号免密号码验证服务
      <br />
      个人信息收集方式：嵌入第三方SDK，SDK收集传输个人信息、设备信息
      <br />
      个人信息收集范围：当前手机号的掩码
      <br />
      隐私政策：
      <a href="https://saas.wostore.cn/solution.html?param=1&num=3">
        https://saas.wostore.cn/solution.html?param=1&num=3
      </a>
      <br />
    </p>
    <h3 class="title">SDK简称：中国电信号码认证SDK</h3>
    <p class="content">
      合作方：中国电信
      <br />
      合作方类型：免密号码友盟合作方
      <br />
      合作目的：提供移动端设备电信手机号免密号码验证服务
      <br />
      个人信息收集方式：嵌入第三方SDK，SDK收集传输个人信息、设备信息
      <br />
      个人信息收集范围：当前手机号的掩码
      <br />
      隐私政策：
      <a
        href="https://e.189.cn/sdk/agreement/content.do?type=main&appKey=&hidetop=true&returnUrl="
      >
        https://e.189.cn/sdk/agreement/content.do?type=main&appKey=&hidetop=true&returnUrl=
      </a>
      <br />
    </p>
    <h3 class="title">SDK 名称：腾讯互联SDK</h3>
    <p class="content">
      合作方：腾讯科技（深圳）有限公司
      <br />
      合作目的：QQ分享
      <br />
      个人信息收集方式：嵌入第三方SDK，SDK收集传个人信息、设备信息
      <br />
      个人信息收集范围：查看WLAN连接；粗略定位；精确定位；读取外置存储卡；读取手机
      <br />
      状态身份；写入外置存储卡；后台访问地理位置
      <br />
      隐私政策：
      <a href="https://wiki.connect.qq.com/qq互联sdk隐私保护声明">
        https://wiki.connect.qq.com/qq互联sdk隐私保护声明
      </a>
      <br />
    </p>
    <h3 class="title">SDK 名称：微信openSDK</h3>
    <p class="content">
      合作方：腾讯科技（深圳）有限公司
      <br />
      合作目的：提供微信APP第三方登录分享服务和第三方支付服务
      <br />
      个人信息收集方式：嵌入第三方SDK，SDK收集传输个人信息
      <br />
      个人信息收集范围：设备MAC地址、唯一设备标识码、位置信息、应用列表
      <br />
      状态身份；写入外置存储卡；后台访问地理位置
      <br />
      隐私政策：
      <a
        href="https://open.weixin.qq.com/cgi-bin/frame?t=news/protocol_developer_tmpl"
      >
        https://open.weixin.qq.com/cgi-bin/frame?t=news/protocol_developer_tmpl
      </a>
      <br />
    </p>
    <h3 class="title">SDK 名称：支付宝SDK</h3>
    <p class="content">
      合作方：蚂蚁金服网络技术有限公司
      <br />
      合作目的：使用支付宝授权在app内进行商品支付
      <br />
      个人信息收集方式：嵌入第三方SDK，SDK收集传个人信息、设备信息
      <br />
      个人信息收集范围：系统运营信息、网络状态信息、iOS广告标识符（IDFA）、MAC地址、
      <br />
      国际移动设备识别码（IMEI）、匿名设备标识符(OAID)、国际移动用户识别码（IMSI）、应用列表信息、基站信息、社交平台OpenID、地理位置
      <br />
      隐私政策：
      <a href="https://opendocs.alipay.com/apis/01g6qm">
        https://opendocs.alipay.com/apis/01g6qm
      </a>
      <br />
    </p>
    <h3 class="title">SDK简称：腾讯x5浏览器内核</h3>
    <p class="content">
      合作方：深圳市腾讯计算机系统有限公司
      <br />
      合作目的：移动浏览场景体验优化
      <br />
      个人信息收集方式：嵌入第三方SDK，SDK收集传个人信息、设备信息
      <br />
      个人信息收集范围：常用设备信息（如IMEI/IMSI、SIM卡序列号/MAC地址、android_id）
      <br />
      设备制造商、网络类型、网络状态、手机操作系统、屏幕尺寸、ip地址
      <br />
      隐私政策：
      <a href="https://x5.tencent.com/tbs/guide/develop.html#5">
        https://x5.tencent.com/tbs/guide/develop.html#5
      </a>
      <br />
    </p>
    <h3 class="title">SDK简称：统一SDK</h3>
    <p class="content">
      合作方：移动安全联盟
      <br />
      合作目的：获取设备唯一标识符
      <br />
      个人信息收集方式：嵌入第三方SDK
      <br />
      个人信息收集范围：UDID、OAID、VAID、AAID
      <br />
      设备制造商、网络类型、网络状态、手机操作系统、屏幕尺寸、ip地址
      <br />
      隐私政策：
      <a href="http://msa-alliance.cn/col.jsp?id=120">
        http://msa-alliance.cn/col.jsp?id=120
      </a>
      <br />
    </p>
    <h3 class="title">SDK简称：OkHttp 网络请求SDK</h3>
    <p class="content">
      合作方：开源
      <br />
      合作目的：提供网络请求服务
      <br />
      个人信息收集方式：嵌入第三方SDK
      <br />
      个人信息收集范围：ip
      <br />

      隐私政策：无
      <br />
    </p>
    <h3 class="title">SDK简称：uni小程序sdk</h3>
    <p class="content">
      所属公司：数字天堂(北京)网络技术有限公司
      <br />
      SDK收集数据的类型：查看WLAN链接
      <br />
      用途：App里面对接小程序，直接拉起打开小程序
      <br />

      隐私政策：
      <a href="https://ask.dcloud.net.cn/article/35623">
        https://ask.dcloud.net.cn/article/35623
      </a>
      <br />
    </p>
    <h3 class="title">SDK简称：uni小程序sdk</h3>
    <p class="content">
      所属公司：数字天堂(北京)网络技术有限公司
      <br />
      SDK收集数据的类型：查看WLAN链接
      <br />
      用途：App里面对接小程序，直接拉起打开小程序
      <br />

      隐私政策：
      <a href="https://ask.dcloud.net.cn/article/35623">
        https://ask.dcloud.net.cn/article/35623
      </a>
      <br />
    </p>
    <h3 class="title">个人信息字段定义以及穷举</h3>
    <p class="content">
      设备MAC地址：设备的mac地址，确认移动设备位置的地址
      <br />
      唯一设备识别码：iOS设备为IDFA，Android设备为IMEI、oaid、AndroidId、UUID（Android以上识别码可能会收集多个）
      <br />
      设备IP地址：移动互联网链接协议，确认网络连接的运营商服务
      <br />
      设备信息：设备品牌、设备型号、操作系统、操作系统版本
      <br />
      网络信息：当前网络环境（如WIFI、5G、4G、3G、2G）
      <br />
      运营商信息：号段归属移动、联通、电信类型
      <br />
      应用列表：判断是否安装了合作的第三方APP（如微信、QQ、新浪微博、淘宝、支付宝、天猫、美团、饿了么）
      <br />
      <span style="font-weight: 1000">（二）转让</span>
      <br />
      我们不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外：
      <br />
      1、在获取明确同意的情况下转让：获得您的明确同意后，我们会向其他方转让您的个人信息；
      <br />
      2、在【{{
        form.appName
      }}】服务提供者发生合并、收购或破产清算情形，或其他涉及合并、收购或破产清算情形时，如涉及到个人信息转让，我们会要求新的持有您个人信息的公司、组织继续受本政策的约束，否则我们将要求该公司、组织和个人重新向您征求授权同意。
      <br />
      <span style="font-weight: 1000">（三）公开披露</span>
      <br />
      我们仅会在以下情况下，公开披露您的个人信息：
      <br />
      1、获得您明确同意或基于您的主动选择，我们可能会公开披露您的个人信息；
      <br />
      2、如果我们确定您出现违反法律法规或严重违反【{{
        form.appName
      }}】平台相关协议及规则的情况，或为保护【{{
        form.appName
      }}】平台用户或公众的人身财产安全免遭侵害，我们可能依据法律法规或征得您同意的情况下披露关于您的个人信息，包括相关违规行为以及【{{
        form.appName
      }}】平台已对您采取的措施。
      <br />
      <span style="font-weight: 1000">
        （四）共享、转让、公开披露个人信息时事先征得授权同意的例外
      </span>
      <br />
      以下情形中，共享、转让、公开披露您的个人信息无需事先征得您的授权同意：
      <br />
      1、与国家安全、国防安全有关的；
      <br />
      2、与公共安全、公共卫生、重大公共利益有关的；
      <br />
      3、与犯罪侦查、起诉、审判和判决执行等司法或行政执法有关的；
      <br />
      4、出于维护您或其他个人的生命、财产相关的重大合法权益但又很难得到本人同意的；
      <br />
      5、您自行向社会公众公开的个人信息；
      <br />
      6、从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开。
      <br />
      请知悉，根据适用的法律，若我们对个人信息采取技术措施和其他必要措施进行处理，使得数据接收方无法重新识别特定个人且不能复原，则此类处理后数据的共享、转让、公开披露无需另行向您通知并征得您的同意。
      <br />
    </p>
    <h3 class="title">四、我们如何存储您的信息</h3>
    <p class="content">
      <span style="font-weight: 1000">（一）存储地点</span>
      <br />
      我们在中华人民共和国境内运营中收集和产生的个人信息，将存储在中国境内。以下情形下，我们会在履行了法律规定的义务后，向境外实体提供您的个人信息：
      <br />
      1、适用的法律有明确规定；
      <br />
      2、获得您的明确授权；
      <br />
      3、您通过互联网进行跨境交易等个人主动行为。
      <br />
      针对以上情形，我们会通过合同等形式确保以不低于本政策规定的程度保护您的个人信息。
      <br />
      <span style="font-weight: 1000">（二）存储期限</span>
      <br />
      我们会采取合理可行的措施，尽力避免收集和处理无关的个人信息。我们只会在达成本政策所述目的所需的期限内保留您的个人信息，除非法律有强制的留存要求，例如《中华人民共和国电子商务法》要求商品和服务信息、交易信息保存时间自交易完成之日起不少于三年。我们判断个人信息的存储期限主要参考以下标准并以其中较长者为准：
      <br />
      1、完成与您相关的交易目的、维护相应交易及业务记录，以应对您可能的查询或投诉；
      <br />
      2、保证我们为您提供服务的安全和质量；
      <br />
      3、您是否同意更长的留存期间；
      <br />
      4、是否存在保留期限的其他特别约定。
      <br />
      在超出保留期间后，我们会在15天内根据适用法律的要求删除您的个人信息，或使其匿名化处理。此外，在注销账户后，我们将在15天内停止为您提供产品和服务，并根据您的要求，删除您的个人信息或匿名化处理，法律法规另有规定的除外。
      <br />
    </p>
    <h3 class="title">五、我们如何保护您的信息</h3>
    <p class="content">
      <span style="font-weight: 1000">
        （一）我们已采取符合业界标准、合理可行的安全防护措施保护您的信息，防止个人信息遭到未经授权访问、公开披露、使用、修改、损坏或丢失。例如，在您的浏览器与服务器之间交换数据时受
        SSL协议加密保护；我们同时对【{{
          form.appName
        }}】网站提供HTTPS协议安全浏览方式；我们会使用加密技术提高个人信息的安全性；我们会使用受信赖的保护机制防止个人信息遭到恶意攻击；我们会部署访问控制机制，尽力确保只有授权人员才可访问个人信息；以及我们会举办安全和隐私保护培训课程，加强员工对于保护个人信息重要性的认识。
        我们指定了专人负责儿童个人信息的保护，严格设定信息访问权限，对可能接触到儿童个人信息的工作人员采取最小够用授权原则，并采取技术措施对工作人员处理儿童个人信息的行为进行记录和管控，避免违法复制、下载儿童个人信息。
      </span>
      <br />
      <span style="font-weight: 1000">
        （二）我们会采取合理可行的措施，尽力避免收集无关的个人信息。我们只会在达成本政策所述目的所需的期限内保留您的个人信息，除非法律有强制的存留要求，例如《中华人民共和国电子商务法》要求商品和服务信息、交易信息保存时间自交易完成之日起不少于三年。而我们判断前述期限的标准包括：
      </span>
      <br />
      1、完成与您相关的交易目的、维护相应交易及业务记录、应对您可能的查询或投诉；
      <br />
      2、保证我们为您提供服务的安全和质量；
      <br />
      3、您是否同意更长的留存期间；
      <br />
      4、是否存在保留期限的其他特别约定。
      <br />
      在您的个人信息超出保留期间后，我们会根据适用法律的要求删除您的个人信息，或使其匿名化处理。
      <br />
      <span style="font-weight: 1000">
        （三）互联网并非绝对安全的环境，使用【{{
          form.appName
        }}】平台服务时，我们强烈建议您不要使用非【{{
          form.appName
        }}】平台的通信方式发送您的信息。您可以通过我们的服务建立联系和相互分享。当您通过我们的服务创建交流、交易或分享时，您可以自主选择沟通、交易或分享的对象，作为能够看到您的交易内容、联络方式、交流信息或分享内容相关信息的第三方。
      </span>
      <br />
      在使用【{{
        form.appName
      }}】服务进行网上交易时，您不可避免地要向交易对方或潜在的交易对方披露自己的个人信息，如联络方式或联系地址。请您妥善保护自己的个人信息，仅在必要的情形下向他人提供。如您发现自己的个人信息尤其是您的账户或密码发生泄露，请您立即联络【{{
        form.appName
      }}】客服，以便我们根据您的申请采取相应措施。
      <br />
      请注意，您在使用我们服务时自愿共享甚至公开分享的信息，可能会涉及您或他人的个人信息甚至个人敏感信息。请您更加谨慎地考虑，是否在使用我们的服务时共享甚至公开分享相关信息。
      请使用复杂密码，协助我们保证您的账号安全。我们将尽力保障您发送给我们的任何信息的安全性。如果我们的物理、技术或管理防护设施遭到破坏，导致信息被非授权访问、公开披露、篡改或毁坏，导致您的合法权益受损，我们将承担相应的法律责任。
      <br />
      <span style="font-weight: 1000">
        （四）我们将不定期更新并公开安全风险、个人信息安全影响有关内容，您可通过【{{
          form.appName
        }}】公告方式获得。
      </span>
      <br />
      <span style="font-weight: 1000">
        （五）在不幸发生个人信息安全事件后，我们将按照法律法规的要求向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施。事件相关情况我们将以邮件、信函、电话通知的方式告知您，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。
      </span>
      <br />
      在不幸发生儿童个人信息安全事件后，我们将按照法律法规的要求，及时向儿童及其监护人告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、儿童及其监护人可自主防范和降低风险的建议、对儿童及其监护人的补救措施。我们将及时将事件相关情况以APP通知、发送邮件/短消息告知儿童及其监护人。难以逐一告知时，我们会采取合理、有效的方式发布相关警示信息。同时，我们还将按照监管部门要求，主动上报儿童个人信息安全事件的处置情况。若儿童及其监护人的合法权益受损，我们将依法承担相应的法律责任。同时，我们还将按照监管部门要求，上报个人信息安全事件的处置情况。
      <br />
    </p>
    <h3 class="title">六、您如何管理您的信息</h3>
    <p class="content">
      您可以通过以下方式访问及管理您的信息：
      <br />
      <span style="font-weight: 1000">（一）查询、更正和补充您的信息</span>
      <br />
      您有权查询、更正或补充您的信息。您可以通过以下方式自行进行：
      <br />
      1、登录手机【{{
        form.appName
      }}】客户端，进入“我的”页面，点击页面右上方设置的图标查询、更正个人资料及个人账户相关信息；
      <br />
      <span style="font-weight: 1000">（二）删除您的信息</span>
      <br />
      您可以通过“（一）查询、更正和补充您的信息”中列明的方式注销您的部分信息。
      <br />
      在以下情形中，您可以向我们提出删除个人信息的请求：
      <br />
      1、如果我们处理个人信息的行为违反法律法规；
      <br />
      2、如果我们收集、使用您的个人信息，却未征得您的明确同意；
      <br />
      3、如果我们处理个人信息的行为严重违反了与您的约定；
      <br />
      4、如果您不再使用我们的产品或服务，或您主动注销了账号；
      <br />
      5、如果我们永久不再为您提供产品或服务。
      <br />
      若我们决定响应您的删除请求，我们还将同时尽可能通知从我们处获得您的个人信息的主体，并要求其及时删除（除非法律法规另有规定，或这些主体已独立获得您的授权）。
      <br />
      当您或我们协助您删除相关信息后，因为适用的法律和安全技术，我们可能无法立即从备份系统中删除相应的信息，我们将安全地存储您的个人信息并将其与任何进一步处理隔离，直到备份可以清除或实现匿名。
      <br />
      <span style="font-weight: 1000">（三）改变您授权同意的范围</span>
      <br />
      如果您不再选择将您的个人信息提供给我们或拒绝使用我们提供的部分服务，您可以通过设置您的智能移动设备关闭您授权给【{{
        form.appName
      }}】的部分权限。以华为手机为例：通过手机中的“设置--隐私--权限管理”，选择关闭部分或全部您已授权给我们的权限。
      当您收回同意后，我们将不再处理相应的个人信息。但您收回同意的决定，不会影响此前基于您的授权而开展的个人信息处理。
      <br />
      <span style="font-weight: 1000">（四）注销您的账户</span>
      <br />
      您可以通过以下方式申请注销您的账户：
      <br />
      1、进入【{{
        form.appName
      }}】手机客户端，选择“我的--注销账户”，您可以注销您的账户。
      <br />
    </p>
    <h3 class="title">七、我们如何处理未成年人的信息</h3>
    <p class="content">
      在电子商务活动中我们推定您具有相应的民事行为能力。如您为未成年人，我们要求您请您的父母或其他监护人仔细阅读本隐私政策，并在征得您的父母或其他监护人同意的前提下使用我们的服务或向我们提供信息。
      <br />
      如果我们识别出您是儿童用户的，请您告知我们您的监护人信息，我们将通知您的监护人并要求您的监护人同意儿童个人信息收集使用规则。对于经父母或其他监护人同意使用我们的产品或服务而收集儿童个人信息的情况，我们只会在法律法规允许、父母或其他监护人明确同意或者保护儿童所必要的情况下使用、共享、转让或披露此信息。
      <br />
      若您是儿童的父母或其他监护人，请您关注您监护的儿童是否是在取得您的授权同意之后使用我们的服务的。如您对您所监护的儿童的个人信息有疑问，请通过第九节中的联系方式与我们联系。
      <br />
    </p>
    <h3 class="title">八、您的信息如何在全球范围转移</h3>
    <p class="content">
      我们在中华人民共和国境内运营中收集和产生的个人信息，存储在中国境内，以下情形除外：
      <br />
      1、适用的法律有明确规定；
      <br />
      2、获得您的明确授权；
      <br />
      3、您通过互联网进行跨境交易的个人主动行为。
      <br />
      针对以上情形，我们会确保依据本隐私政策对您的个人信息提供足够的保护。
      <br />
    </p>
    <h3 class="title">九、本隐私政策如何更新</h3>
    <p class="content">
      我们的隐私政策可能变更。
      <br />
      未经您明确同意，我们不会限制您按照本隐私政策所应享有的权利。我们会在App上发布对隐私政策的更新。
      <br />
      对于重大变更，我们还会提供更为显著的通知（包括我们会通过【{{
        form.appName
      }}】公示的方式进行通知甚至向您提供弹窗提示）。
      <br />
      本政策所指的重大变更包括但不限于：
      <br />
      1、我们的服务模式发生重大变化。如处理个人信息的目的、处理的个人信息类型、个人信息的使用方式；
      <br />
      2、我们在控制权方面发生重大变化。如并购重组引起的信息控制者变更；
      <br />
      3、个人信息共享、转让或公开披露的主要对象发生变化；
      <br />
      4、您参与个人信息处理方面的权利及其行使方式发生重大变化；
      <br />
      5、我们负责处理个人信息安全的责任部门、联络方式及投诉渠道发生变化；
      <br />
      6、个人信息安全影响评估报告表明存在高风险。
      <br />
    </p>
    <h3 class="title">十、如何联系我们</h3>
    <p class="content">
      您可以通过以下方式与我们联系，我们将在15天内回复您的请求：
      <br />
      1、如对本政策内容、儿童个人信息有任何疑问、意见或建议，您可通过【{{
        form.appName
      }}】客服邮箱：【{{ form.companyEmail }}】与我们联系。
      <br />
      2、如发现个人信息可能被泄露，您可以联系我们的客服人员进行投诉举报；
      <br />
      如果您对我们的回复不满意，特别是您认为我们的个人信息处理行为损害了您的合法权益，您还可以通过向被告住所地有管辖权的法院提起诉讼来寻求解决方案。
      <br />
    </p>
  </div>
</template>

<script>
  import { getAll } from "@/api/seting";
  export default {
    data() {
      return {
        //系统设置
        form: {},
      };
    },
    created() {},
    mounted() {
      this.getAll();
    },
    methods: {
      getAll() {
        getAll().then((res) => {
          if (res.status) {
            this.form = res.data;
          }
        });
      },
    },
  };
</script>

<style scoped>
  .title {
    text-align: left;
  }
  .content {
    text-align: left;
  }
</style>
